
import React from 'react';
import { NikoFacilityOrderNewFlowInventoryCalculationVerificationModalTemplate } from 'themes/application/niko-facility-order-inventory/components';
import { observer } from 'mobx-react';
import { setCurrentView } from 'core/utils';
import { NikoFacilityOrderNewFlowInventoryCalculationVerificationModalStore } from 'application/niko-facility-order-inventory/stores';

@setCurrentView((rootStore, componentProps) => new NikoFacilityOrderNewFlowInventoryCalculationVerificationModalStore(rootStore, componentProps), 'nikoFacilityOrderNewFlowInventoryCalculationVerificationModalStore')
@observer
class NikoFacilityOrderNewFlowInventoryCalculationVerificationModal extends React.Component {
    render() {
        return <NikoFacilityOrderNewFlowInventoryCalculationVerificationModalTemplate {...this.props} />
    }
}

export default NikoFacilityOrderNewFlowInventoryCalculationVerificationModal;
